import {createContext} from '../context';

export const context = createContext();
